module.exports = __webpack_public_path__ + "img/trust__down-main-1.b21e3e43.jpg";